import * as yup from 'yup';

export const schemaValidation = yup
  .object({
    cod_pais: yup.number().min(0).max(9999).required(),
    des_pais: yup.string().trim().required(),
  })
  .required();
